export default function usePlayersCount(setTotalPlayers) {
    const setPlayers = setTotalPlayers;
    const getPlayersCount = (iteration, offset) => {
        const step = Math.pow(51, iteration);
        const request = guess(offset, step);
        fetch(request)
            .then((res) => res.json())
            .then((data) => {
                const players = data;
                if (iteration === 0) {
                    const amount = players[players.length - 1].id;
                    setPlayers(amount);
                } else
                    getPlayersCount(
                        iteration - 1,
                        offset + (players.length - 1) * step
                    );
            });
    };
    return getPlayersCount;
}

function guess(start, step) {
    let request = 'https://api.vime.world/user/';
    for (let i = 0; i < 50; i++) {
        const id = start + i * step;
        request = request + '' + id + ',';
    }
    return request;
}
